import { render } from "./PictureViewer.vue?vue&type=template&id=2b119b50&ts=true"
import script from "./PictureViewer.vue?vue&type=script&lang=ts"
export * from "./PictureViewer.vue?vue&type=script&lang=ts"

import "./PictureViewer.vue?vue&type=style&index=0&id=2b119b50&lang=scss"

import exportComponent from "D:\\封面新闻\\activity\\ssccloudtour\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__